export default __webpack_public_path__ + "img/bf3c102f64015a6f31b6c0ad17904da6.png";